import { css, styled } from "src/styles/theme";

const text = css({
  margin: 0,
  lineHeight: 1,
  variants: {
    color: {
      neutral: {
        color: "$neutralText",
      },
      neutralContrast: {
        color: "$neutralTextContrast",
      },
      primary: {
        color: "$primaryText",
      },
      primaryContrast: {
        color: "$primaryTextContrast",
      },
    },
    size: {
      xs: { fontSize: "$xs" },
      sm: { fontSize: "$sm" },
      base: { fontSize: "$base" },
      lg: { fontSize: "$lg" },
      xl: { fontSize: "$xl" },
      "2xl": { fontSize: "$2xl" },
      "3xl": { fontSize: "$3xl" },
      "4xl": { fontSize: "$4xl" },
      "5xl": { fontSize: "$5xl" },
      "6xl": { fontSize: "$6xl" },
      "7xl": { fontSize: "$7xl" },
      "8xl": { fontSize: "$8xl" },
      "9xl": { fontSize: "$9xl" },
    },
    weight: {
      light: { fontWeight: "$light" },
      normal: { fontWeight: "$normal" },
      medium: { fontWeight: "$medium" },
      semibold: { fontWeight: "$semibold" },
      bold: { fontWeight: "$bold" },
    },
    align: {
      start: {
        textAlign: "start",
      },
      center: {
        textAlign: "center",
      },
      end: {
        textAlign: "end",
      },
    },
  },
  defaultVariants: {
    color: "neutral",
  },
});

export const Text = styled("div", text);
export const Quote = styled("q", text);
export const Paragraph = styled("p", text, { lineHeight: 1.8 });
export const ListItem = styled("li", text);
export const Small = styled("small", text);
export const Deleted = styled("del", text);
export const H1 = styled("h1", text);
export const H2 = styled("h2", text);
export const H3 = styled("h3", text);
export const H4 = styled("h4", text);
export const H5 = styled("h5", text);
export const H6 = styled("h6", text);

export const Em = styled("em", text, { fontStyle: "italic" });
export const Strong = styled("strong", text, { fontWeight: "$bold" });

export const Link = styled("a", text, {
  textDecoration: "none",

  defaultVariants: {
    color: "primary",
  },
});

export const Title = styled("h1", text, {
  fontSize: "$3xl",
  lineHeight: 1.2,

  "@medium": {
    fontSize: "$5xl",
  },

  defaultVariants: {
    color: "primaryContrast",
    weight: "bold",
  },
});

export const Subtitle = styled("h2", text, {
  fontSize: "$xl",
  lineHeight: 1.2,

  "@medium": {
    fontSize: "$2xl",
  },

  defaultVariants: {
    color: "primaryContrast",
    weight: "normal",
  },
});
